import { render, staticRenderFns } from "./ModalDuplicateWorkflow.vue?vue&type=template&id=18d378de&scoped=true&"
import script from "./ModalDuplicateWorkflow.vue?vue&type=script&lang=js&"
export * from "./ModalDuplicateWorkflow.vue?vue&type=script&lang=js&"
import style0 from "./ModalDuplicateWorkflow.vue?vue&type=style&index=0&id=18d378de&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18d378de",
  null
  
)

export default component.exports